import { useId } from 'react';
import { cn } from '../../lib/utils';

/** The horizontal Chetty logo on a bare surface. The artwork is split once from `docs/brand/chetty-logo.png`:
 *  the mascot and the `.ai` accent keep their colours (`chetty-logo-art.png`), while the "Chetty" lettering
 *  is only an alpha mask (`chetty-logo-wordmark.png`) filled with `currentColor`, so the word follows the
 *  surrounding text colour in every skin, light ones included, without a backing plate. */
export function ChettyLogo({ className }: { className?: string }) {
  const mask = useId();
  return (
    <svg viewBox="0 0 640 180" role="img" aria-label="Chetty" data-slot="chetty-logo" className={cn('h-auto text-foreground', className)}>
      <mask id={mask} maskUnits="userSpaceOnUse" x="0" y="0" width="640" height="180">
        <image href="/chetty-logo-wordmark.png" width="640" height="180" />
      </mask>
      <image href="/chetty-logo-art.png" width="640" height="180" />
      <rect width="640" height="180" fill="currentColor" mask={`url(#${mask})`} />
    </svg>
  );
}
